import { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function useCurrencyField(fieldName) {
  const { values, setFieldValue } = useFormikContext();
  const [inputValue, setInputValue] = useState('');

  const getValueFromNestedPath = (obj, path) => {
    return path.split('.').reduce((acc, key) => acc && acc[key], obj);
  };

  const formValue = getValueFromNestedPath(values, fieldName);

  //console.log("Form value for", fieldName, "=", formValue);
  //console.log("values object:", values);
  useEffect(() => {
    if (document.activeElement?.name !== fieldName) {
      if (formValue === null || formValue === undefined || formValue === '') {
        setInputValue('');
      } else if (!isNaN(formValue)) {
        setInputValue(currencyFormatter.format(Number(formValue)));
      } else {
        setInputValue(formValue);
      }
    }
  }, [formValue, fieldName]);

  const handleFocus = () => {
    if (formValue === null || formValue === undefined || formValue === '') {
      setInputValue('');
    } else {
      setInputValue(String(formValue));
    }
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleBlur = (e) => {
    const cleaned = e.target.value.replace(/[^0-9.-]+/g, '');
    const parsed = parseFloat(cleaned);
    const safeValue = isNaN(parsed) ? '' : parsed;

    setFieldValue(fieldName, safeValue);

    if (safeValue === '') {
      setInputValue('');
    } else {
      setInputValue(currencyFormatter.format(safeValue));
    }
  };

  return {
    name: fieldName,
    value: inputValue,
    onFocus: handleFocus,
    onChange: handleChange,
    onBlur: handleBlur,
  };
}
